module.exports = __webpack_public_path__ + "static/img/dialog2.5b86267.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dialog2.jpg
// module id = w23j
// module chunks = 159